var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardList"},[_c('ul',_vm._l((_vm.listdata),function(it,index){return _c('li',{key:index,style:({ 'background-image': 'url(' + it.img + ')' })},[_c('div',[_c('p',[_vm._v(_vm._s(it.title))])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }